import { UsersService } from '../services';
import { usersKeys } from '../queryKeys';
import { INTERNAL_USERS_DEFAULT_LIMIT } from '../clients/GetInternalUsers';
import { useUsersPageQuery } from './useUsersPageQuery';

export const GOTU_ADMINS_PAGE_SIZE = INTERNAL_USERS_DEFAULT_LIMIT;

/**
 * A page of GoTu Admins for the list page.
 *
 * pageSize is fixed at the endpoint's default rather than exposed: the story
 * specifies 15 and nothing else asks for a different size.
 *
 * @param {Object} [params]
 * @param {number} [params.page=1] - 1-based page.
 * @param {string} [params.search=''] - Matches name or email.
 * @param {string[]} [params.roles=[]] - Role slugs; empty means every role.
 */
export const useGetInternalUsers = ({ page = 1, search = '', roles = [] } = {}) => {
  const { rows, ...query } = useUsersPageQuery(
    usersKeys.internalUsers({ search, roles }, page),
    () =>
      UsersService.getInternalUsers({
        page,
        limit: GOTU_ADMINS_PAGE_SIZE,
        search,
        roles,
      }),
    GOTU_ADMINS_PAGE_SIZE,
  );

  return { admins: rows, ...query };
};
